<template>
	<div id="transcriptsDashboard" class="row no-bottom-margin">

		<div class="loader-container" v-if="!ready">
				<div 
				class="preloader-wrapper small active">
				<div class="spinner-layer spinner-blue-only">
				<div class="circle-clipper left">
					<div class="circle"></div>
				</div><div class="gap-patch">
					<div class="circle"></div>
				</div><div class="circle-clipper right">
					<div class="circle"></div>
				</div>
				</div>
				</div>
			</div>
		<div id="eStateHolder" v-if="!ready">
			<empty-state
        :show-button="true">
				<template #header>{{timeOfDay}} {{user.name}}</template>
				<template #content>
					<div>
						You currently have no records in the list please select create a record below to begin
					</div>
				</template>
				<template #action>
          <router-link :to="{name:'new_record'}" class="btn-medium btn indigo accent-4 white-text">Create New Record</router-link>
				</template>
			</empty-state>
		</div>
			<div class="col s12 no-float center-aligned white">
			<div class="learners-banner">
				<div class="search-input">
					<div class="col s12  no-padding">
						<div class=" input-field  col s8 ">
								<input type="text" class="eval-search white" id="search">
						</div>
						<div class="col s4 input-field ">
							<button class="btn btn-medium waves-effect">Search</button>
						</div>
					</div>
				</div>

			<div class="bg-element" v-bind:style="{backgroundImage:'url('+pattern+')'}" ></div>
		</div>
		<div class="clear"></div>
        <div style="width:100%; height:1px; background-color:rgba(0,0,0,.05)"></div>
          <div class="col s12 l9 m10 push-l1 listing-view">
            <div class="col s12">
							<div class="col s12">
							<div class="add-card card ">
              <div class="card-content ">
								<div class="card-title">
									End of Appointment Assessment Form
								</div>
								<div class="excerpt left" style="width: calc(100% - 70px">
									Click on the button below to complete the review process. If you already begin select edit from the list under the submissions heading
								</div>
								<img :src="fillIn" class="right circle" width="65px" >
								<div class="clear"></div>
              </div>
							<div class="card-action">
								<router-link  :to="{name:'new_eval'}" class="btn btn-medium waves-effect white-text">Click to begin</router-link>
							</div>
            </div>
							</div>
            </div>
            <div class="col s12" v-if="role === 'admin'">
							<div class="col s12 lists">
									<h4>Users Submissions</h4>
							</div>
							<div class="col s12 m6" v-for="item in parsedItems" :key="item.id">
								<div class="card">
									<div class="card-content">
										<div class="date">{{$_dateFormat(item.date)}}</div>
										<div class="card-list-title left tuncate" ><span v-html="item.title.rendered"></span>	</div> <br>
										
										<div v-text="item.fields.status"></div>
										<div class="clear"></div>
									</div>
									<div class="card-action">
										<router-link  :to="{name:'view_eval', params:{id: item.id}}" class="btn-flat waves-effect blue-text"> Continue editing</router-link>
										<button class="btn-flat waves-effect red-text">Delete</button>
									</div>
								</div>
							</div>
            </div>
						<div class="col s12">

						</div>
            <div class="clear"></div>
          </div>
			</div>
	
		<div class="pickers" id="pickerContainer">
			
		</div>
		<!-- diglog  Modal -->
    <div class="dialog" ref="dialogComponent"></div>
    <!-- block list Modal -->
		<router-view @fetch="$_getAllSubmissions()" />
	</div>
</template>
<script>
import core from '@/functions'
import pattern from '@/assets/future_web.svg'
import dialogComponent from '@/components/dialog.component'
import contentService from '@/services/contentService'
import fillIn from '@/assets/fillIn.png'
import estate from '@/assets/estate.svg'
import Vue from 'vue'
import { mapState } from 'vuex'
import emptyState from '@/components/emptyState.component'
export default {
	name: 'evaluations',
	components: {
		emptyState,
		
		
		// eslint-disable-next-line vue/no-unused-components
		dialogComponent,
	},
	data() {
		return {
			estate,
			fillIn,
			pattern,
      items: [],
			ready:false,
			pagination: {
        page: 1,
        per: 20
      }
		};
	},
	mounted() {
		this.users.length < 1 
		? this.$_fetchUsers()
		: false
		this.companies.length < 1 
		? this.$_getCompanies()
		: false
		this.ready = true
		this.$_getAllSubmissions()
	},
	computed: {
		...mapState({
			user: state => state.user,
			authUser: state => state.authUser,
			users:state=> state.record.users,
			companies:state=> state.record.companies
		}),
		role:{
			get () {
				return this.user.acf.role ? this.user.acf.role : 'other'
			}
		},
		currentRoute:{
			get(){
				return this.$route.name
			}
		},
		parsedItems: {
			get () {
				const display = (f) => {
					const fDetails = JSON.parse(f.acf.form_string)
					return {
						id:f.id,
						date: f.date,
						title: f.title,
						fields: {
							for: fDetails.find(prop => prop.name === 'judicial_officer').values,
							status:f.acf.status
						}
					}
				}
				return this.items.map( item => display(item))
			}
		},
		timeOfDay: function() {
			let today = new Date();
			let curHr = today.getHours();
			if (curHr < 12) {
				return "Good Morning";
			} else if (curHr < 18) {
				return "Good Afternoon";
			} else {
				return "Good Evening";
			}
		},
	},
	watch:{
		$route:function(nV){
			if(nV && nV.name === 'records') {
	/* 
			this.$_getCompanies()
			this.$_fetchUsers() */
			}
		
		}
	},
	methods: {
		$_dateFormat (d) {
			return core.dateFormat(new Date(d),'DD MMM YYYY')
		},
		$_getAllSubmissions () {
			const getAsAdmin = () => {
				contentService.getForms({page:1, per:20})
					.then(res=> {
						this.items = res.data
					})
					.catch(err => {
						return err
					})
			}
			const getAsUser = () => {
				contentService.getForms({page:1, per:20, author:this.user.id})
					.then(res=> {
						this.items = res.data
					})
					.catch(err => {
						return err
					})
			}

			this.role === 'admin' 
			? getAsAdmin()
			: getAsUser()
		},
		$_formatDate(date, format){
			return core.dateFormat(new Date(date), format)
    },
		$_getCompanies(){
			contentService.getRecordsCompanies()
			.then(res=>{
				this.$store.commit('SAVE_COMPANIES', res.data)
			})
			.catch(err=>{
				window.console.warn(err)
			})

		},
		dialogMessages(data) {
      let ComponentClass = Vue.extend(dialogComponent);
      let instance = new ComponentClass({
        propsData: data
      });
      let link = instance.$createElement("div", {
        attrs: {
          class: "context"
        },
        domProps: {
          innerHTML: data.message
        }
      });

      instance.$slots.default = [link];
      instance.$slots["title"] = [data.title];
      instance.$mount(); // pass nothing
      this.$refs.dialogComponent.appendChild(instance.$el);
    },
		$_deleteRecord(id){
		let data = {
				title:'Delete Record',
        message: "Are you sure you want to delete this record?",
        buttons: [
          {
            id: 0,
            value: "cancel",
            action: () => {},
            close: true
          },
   
          {
            id: 2,
            value: "Delete",
            action: () => {
						contentService.deleteRecord(id)
							.then(res=>{
								if(res.data.id){
									this.$store.commit('DELETE_RECORD', id)
									core.toastMessage('Successfully deleted record')
								}
							})
            },
            close: true
          }
        ]
      };
			this.dialogMessages(data);
		},
		$_fetchUsers(){
			contentService.getRecordsUsers()
			.then(res=>{
				this.$store.commit('SAVE_USERS', res.data)
			})
			.catch(err=>{
				window.console.warn(err)
			})
		},
		$_matchUser(id){
			const user =  this.users.find(user => user.id === id)
			return user ? user.acf.first_name+' '+user.acf.last_name : 'not a user'
		},
	}
};
</script>
<style scoped lang="scss">
div#transcriptsDashboard {
	min-height: 80vh;
	position: relative;
	@media screen and (min-width: 1024px) {
		width: 100%;
		padding-left: 300px;
	}
	#eStateHolder {
		left: 50%;
		top: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
		@media screen and (min-width: 1024px) {
			transform: translate(calc(-50% + 150px), -50%);
		}
	}
	.title-section {
		font-size: 24px;
		line-height: 1.5;
		margin: 12px 0px 12px 0px;
	}
	.page-meta {
		transform: translateY(-16px);
		position: relative;
		&::after {
			content:'Forms Lists';
			position: absolute;
			bottom:-16px;
			left:2px;
			font-size: 14px;
			letter-spacing: 1px;
		}
	}
	.clearbtn {
    position: absolute;
    right: 9px;
    top: 16px;
    cursor: pointer;
			i {
        font-size: 18px;
      }
  }
	
	.tsc {
		position: relative;
		&::before {
			content: "search";
			font-family: "Material Icons";
			font-size: 21px;
			position: absolute;
			top: 10px;
			color: #8f8f8f;
			left: 12px;
		}
	}
	.circle-tar {
		border-radius:50%;
		width:50px;
		height:50px;
	}
button.btn.cs-btn {
    padding: 0px 4px;
    height: 30px;
    line-height: 29px;
    margin-right: 5px;
}
.loader-container {
		position: fixed;
		top:50%;
		left:50%;
		transform:translate(-50%,-50%);
			@media screen and (min-width:1024px){
				left:calc(50% + 300px);
				transform:translate(calc(-50% - 250px),-50%);
			}
	}
  .listing-view {
    margin-top:24px;
	}
	.add-card {
		margin-top: 24px;
		margin-bottom: 24px;
	}
  .card {
    border-radius: 4px;
    overflow: hidden;
    .card-content {
      padding:16px;
    }
		.card-title {
			font-size: 22px;
			font-weight: 400;
			line-height: 26px;
		}
		.card-list-title {
				font-size: 16px ;
				font-weight: 500;
				line-height: 21px;
			}
    .card-action {
      padding: 10px 12px;
    }
    blockquote {
      font-size: 12px;
      padding-left: 8px;
      border-left: 4px solid #304ffe;
      font-style: italic;
      font-weight: 300;
      margin: 7px 2px;
    }
  }
  .date-recieved {
    font-size:12px;
	}
	.search-input {
		position: absolute;
    margin: 0px;
    padding: 0px;
    max-width: 570px;
    z-index: 9;
    left: 134px;
    top: 50%;
    transform: translateY(-60%);
		width: 100%;
	.input-field {
		.eval-search {
			border: 1px solid rgba(0, 0, 0, 0.08);		
			border-radius: 4px;
			padding: 0px 24px;
			width: calc(100% - 48px);
		}
	}
	}
}

.learners-banner {
    background:rgb(250, 250, 250);
    padding: 46px 48px;
    background-size: 50%;
    background-position: right top;
    background-repeat: no-repeat;
		height:300px;
		position: relative;
		overflow: hidden;
		margin: 0 -8px;
    @media screen and (max-width:768px) {
      padding: 24px 28px;
    }
    .bg-element {
      position: absolute;
      top:0;
      right:0px;
      height: calc(100% + 64px);
      width:45%;
      background-size: cover !important;
    }
    .user-title {
      font-size:32px;
      margin:12px 0px;
      line-height: 1;
    }
    .short-text {
      p {
        font-size:17px;
        line-height: 1.6; 
        opacity: .9;
        margin:4px 0px 16px;
      }
    }
}
</style>
